export default {
  dbi_genre_profile: '品类画像',
  dbi_genre_performance: '品类表现',
  dbi_genre_profile_stats_mscience_info: 'Mscience日粒度数据仅适用于美国。',
  dbi_genre_profile_stats_mobile_info:
    '手游收入和下载数据取Databrain数据库所有可用数据的汇总值。',
  dbi_genre_profile_search_games: '在表格内搜索任一游戏',
  dbi_genre_profile_search_countries: '在表格内搜索任一国家',
  dbi_genre_profile_search_companies: '在表格内搜索任一公司',
  dbi_genre_profile_search_genre: '在表格内搜索任一品类',

  dbi_genre_profile_metric_mobile_downloads: '手游下载量',
  dbi_genre_profile_metric_percent_market: '市场占比',
  // 详情页
  dbi_genre_profile_strategy: '策略',
  dbi_genre_profile_by_countries: '按国家',
  dbi_genre_profile_data_source_info_mobile:
    '收入和下载数据来源于SensorTower，Sensor Tower品类体系的收入和下载数据取自该数据源的市场规模版块，并非数据库中所有游戏数据汇总。',
  dbi_genre_profile_data_source_info:
    '收入和下载数据都基于数据库中所有可用数据的聚合',
  dbi_genre_profile_data_source_info_pc_console:
    '线上收入和零售收入都基于数据库中所有可用数据的聚合',
  dbi_genre_profile_data_desc: '数据描述',
  dbi_genre_profile_steam_pcu: 'Steam 最高同时在线玩家',
  dbi_genre_profile_steam_trending: 'Steam新游榜',
  dbi_genre_profile_monthly_digital_revenue: '每月线上收入（美元）',
  dbi_genre_profile_monthly_physical_revenue: '每月零售收入',
  dbi_genre_profile_newzoo_mau: '月活跃玩家数',
  dbi_genre_profile_daily_steam_pcu: 'Steam 每日最高同时在线玩家',

  dbi_genre_profile_big_riser_bubble_dominate: 'Big Riser 霸榜至少7天',
  dbi_genre_profile_big_riser_bubble_new: '首次进入Big Riser榜单',
  dbi_genre_profile_big_riser_bubble_other: 'Big Riser 霸榜至少2天',
  dbi_genre_profile_big_riser_bubble_keyword_dominate: '7天',
  dbi_genre_profile_big_riser_bubble_keyword_new: '新',
  dbi_genre_profile_big_riser_bubble_keyword_other: '剩余',
  dbi_genre_profile_new_blockbuster_games_tips:
    '重磅新游(New Blockbuster Games)选自近期发布上线的突增游戏(Big Riser Games)，突增游戏取自首次进data.ai收入和下载量排名头部的游戏。',
  dbi_genre_profile_new_blockbuster_pc_tip:
    '重磅新游(New Blockbuster Games)选自近期发布上线的突增游戏(Big Riser Games)，突增游戏取自首次进入Steam Top Seller榜单、Mscience收入排名头部以及MAU排名头部的游戏。',
  dbi_genre_profile_new_blockbuster_module_name: '重磅新游',
  dbi_genre_profile_market_crten_module_name: '按收入前10划分的市场',
  dbi_genre_profile_big_riser_module_name: '大型',
  dbi_genre_profile_new_release_module_name: '新发布',
  dbi_genre_profile_upcoming_module_name: '即将发布',

  dbi_genre_profile_trend: '趋势',
  dbi_genre_profile_top_games: '热门游戏',
  dbi_genre_profile_top_countries: '热门国家',
  dbi_genre_profile_top_companies: '热门公司',
  dbi_genre_profile_data_category: '数据类别',

  dbi_genre_profile_top_game_revenue: '按收入的头部游戏',
  dbi_genre_profile_top_game_digital_revenue: '按线上收入的头部游戏',

  dbi_genre_profile_main_genre_tips:
    '主品类不等于副品类之和是因为游戏的IEGG品类会有一个主品类两个副品类。',
};
